import {FunnelKey} from "./Keys";
import {FunnelGroupCell} from "./FunnelGroupLine";
import {RoleCell} from "./RoleCell";

export type VisibleCellInfo<T> = {
    cell: T;
    offset: number;
    keys: FunnelKey[];
    prev: FunnelKey | null,
    next: FunnelKey | null,
}

type BaseCell = FunnelGroupCell | RoleCell;

export class VisibleCell {
    static readonly NOT_JOINABLE_VALUE = '.'; // 実際の値
    static readonly NOT_JOINABLE_VALUE_FACE = '';   // 表示上の値

    static makeVisibleCellList<T extends BaseCell>(cells: T[]): VisibleCellInfo<T>[] {
        // cells(key=>name} [A => 'a', B => 'b', C => 'b', D => 'c']
        // visible_list   [
        //                  {cell: [A=>'a'], offset:0, keys:[A]  , prev:null, next:B   },
        //                  {cell: [B=>'b'], offset:1, keys:[B,C], prev:A   , next:D   },
        //                  {cell: [C=>'b'], offset:2, keys:[]   , prev:null, next:null},
        //                  {cell: [D=>'c'], offset:3, keys:[D]  , prev:B   , next:null},
        //                ]

        let dup_count = 0;
        let prev: FunnelKey | null = null;
        let next: FunnelKey | null = null;
        return cells.map((c, i) => {

            if (0 < dup_count) {
                --dup_count;
                return {cell: c, offset: i, keys: [], prev: null, next: null};
            }

            const keys: FunnelKey[] = [cells[i].Key];
            for (; dup_count + i + 1 < cells.length; ++dup_count) {
                if (c.Name === VisibleCell.NOT_JOINABLE_VALUE || cells[dup_count + i + 1].Name !== c.Name) {
                    next = cells[dup_count + i + 1].Key;
                    break;
                }
                keys.push(cells[dup_count + i + 1].Key);
            }
            if (dup_count + i + 1 === cells.length) {
                next = null;
            }

            const fixed_prev = prev;
            prev = c.Key;
            return {cell: c, offset: i, keys: keys, prev: fixed_prev, next: next};
        });
    }

    static getOstensibleValue(value: string) {
        return value === VisibleCell.NOT_JOINABLE_VALUE ? VisibleCell.NOT_JOINABLE_VALUE_FACE : value;
    }

    static isChangeableValue(from: string, to: string) {
        return (from !== to) && !(from === VisibleCell.NOT_JOINABLE_VALUE && to === VisibleCell.NOT_JOINABLE_VALUE_FACE);

    }
}